export const name = 'search';

export const renderMenu = (renderOptions, isFirstRender) => {
//    const { items, widgetParams, refine } = renderOptions;
    const { widgetParams, refine } = renderOptions;
    const container = document.querySelector(widgetParams.container);

    if( !container ) {
        return;
    }

    // items.forEach(function(item) {
    //     container.innerHTML = `${items.map( item => `<button data-value="${item.value}">Areas ${item.label}</button>`).join('')}`;
    // });

    if( isFirstRender ) {
        container.querySelectorAll('button').forEach(element => {
            element.addEventListener('click', event => {
                event.preventDefault();
                refine(event.currentTarget.dataset.value);
            });
        });
    }
};

export const renderRefinementList = (renderOptions) => {
    const { items, refine, widgetParams } = renderOptions;

    if( items.length == 0 ) {
        widgetParams.container.innerHTML = '<p style="text-align: center; margin: 1em 0">There are no filters available for this content</p>';
    } else {
        widgetParams.container.innerHTML = `
      ${items
            .map(
                item => `
              <a
                href="#"
                data-value="${item.value}"
                class="${item.isRefined ? 'active' : ''}"
              >
                ${item.label}
              </a>`
            )
            .join('')}
  `;
    }

    widgetParams.container.querySelectorAll('a').forEach(element => {
        element.addEventListener('click', event => {
            event.preventDefault();
            refine(event.currentTarget.dataset.value);
            widgetParams.container.hidden = true;
        });
    });
};

export const renderInfiniteHits = (renderOptions, isFirstRender) => {
    const { hits, showMore, isLastPage, widgetParams } = renderOptions;
    const resultsContainer = document.querySelector(widgetParams.container);
    const moreButton = document.querySelector(widgetParams.moreContainer);
    const renderer = widgetParams.renderFunction;

    resultsContainer.innerHTML = window[renderer](hits);

    if( isFirstRender ) {
        moreButton.addEventListener('click', () => {
            showMore();
        });
    } else {
        moreButton.hidden = isLastPage;
    }
};